ีีี
<template>
  <div class="state-answer" v-if="isShow">
    <div class="dash" />
    <div class="label-state">คำตอบของคุณ</div>
    <div class="body">
      <div class="line" />
      <div
        class="answer"
        v-for="item in items"
        :key="item.path"
        :class="{ active: item.active }"
        @click="item.active ? undefined : $router.push(item.path)"
      >
        <img v-if="item.image" :src="item.image" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import IMG from "@/assets/images/questions";

export const IMAGE = IMG;

export const QUESTION_INFO = [
  // {
  //   path: "/questions/character",
  //   name: "gender",
  //   label: "เลือกตัวละครของคุณ",
  //   options: [
  //     {
  //       value: "male",
  //       image: IMG.CHARACTER_MALE,
  //       label: "ผู้ชาย",
  //       nextPath: "/questions/person_type",
  //     },
  //     {
  //       value: "female",
  //       image: IMG.CHARACTER_FEMALE,
  //       label: "ผู้หญิง",
  //       nextPath: "/questions/person_type",
  //     },
  //   ],
  // },
  // {
  //   path: "/questions/job",
  //   name: "job",
  //   label: "ปัจจุบันคุณประกอบอาชีพ\nประเภทไหน",
  //   options: [
  //     {
  //       value: "online_selling",
  //       image: IMG.JOB_ONLINE_SELLING,
  //       label: "ขายสินค้า\nเช่นขายของออนไลน์",
  //       nextPath: "/questions/person_type",
  //     },
  //     {
  //       value: "service",
  //       image: IMG.JOB_SERVICE,
  //       label: "บริการอื่นๆ\nเช่น Youtuber/รับรีวิวสินค้า",
  //       nextPath: "/questions/person_type",
  //     },
  //   ],
  // },
  {
    path: "/questions/person_type",
    name: "taxType",
    label: "ปัจจุบันคุณเสียภาษีในนาม\nบุคคลธรรมดาหรือนิติบุคคล?",
    options: [
      {
        value: "personal",
        image: IMG.PERSON_TYPE_PERSONAL,
        label: "บุคคลธรรมดา",
        nextPath: "/questions/income_rate",
      },
      {
        value: "corp",
        image: IMG.PERSON_TYPE_CORP,
        label: "นิติบุคคล",
        nextPath: "/questions/income_rate",
      },
    ],
  },
  {
    path: "/questions/income_rate",
    name: "isIncomeOver",
    label: "รายได้จากธุรกิจของคุณมากกว่า\nปีละ 1.8 ล้านบาทหรือไม่?",
    options: [
      {
        value: true,
        image: IMG.INCOME_RATE_TRUE,
        label: "มากกว่า 1.8 ล้านบาทต่อปี",
        nextPath: "/questions/vat",
      },
      {
        value: false,
        image: IMG.INCOME_RATE_FALSE,
        label: "น้อยกว่า 1.8 ล้านบาทต่อปี",
        nextPath: "/questions/vat_needed",
      },
    ],
  },
  {
    path: "/questions/vat",
    name: "isRegisteredVat",
    label: "คุณจด VAT หรือยัง?",
    options: [
      {
        value: true,
        image: IMG.VAT_TRUE,
        label: "จดแล้วหรือได้รับการยกเว้น",
        nextPath: "/questions/goods_type",
      },
      {
        value: false,
        image: IMG.VAT_FALSE,
        label: "ยังไม่จด",
        nextPath: "/forms/register_vat_input",
      },
    ],
  },
  {
    path: "/questions/vat_needed",
    name: "isWantToRegisterVat",
    label: "ต้องการจด VAT ไหม?",
    options: [
      {
        value: true,
        image: IMG.VAT_NEEDED_TRUE,
        label: "ต้องการจด VAT",
        nextPath: "/summaries/personal_need_register",
      },
      {
        value: false,
        image: IMG.VAT_NEEDED_FALSE,
        label: "ไม่ต้องการจด VAT",
        nextPath: "/summaries/personal_not_register",
      },
    ],
  },
  {
    path: "/questions/goods_type",
    name: "goodsType",
    label: "ปัจจุบันคุณซื้อสินค้าแบบไหน",
    options: [
      {
        value: true,
        image: IMG.GOODS_TYPE_TRUE,
        label: "สินค้าแบบมี VAT",
        nextPath: "/forms/corp_profit",
      },
      {
        value: false,
        image: IMG.GOODS_TYPE_FALSE,
        label: "สินค้าแบบไม่มี VAT",
        nextPath: "/forms/corp_profit",
      },
    ],
  },
  {
    path: "/questions/cheat",
    name: "isCheat",
    label: "ลองยื่น\nรายได้ต่ำกว่าความจริงไหม",
    options: [
      {
        value: true,
        image: IMG.CHEAT_TRUE,
        label: "ลอง",
        nextPath: "/forms/cheat_income",
      },
      {
        value: false,
        image: IMG.CHEAT_FALSE,
        label: "ไม่ลอง",
        nextPath: "/questions/final_decision",
      },
    ],
  },
  {
    path: "/questions/final_decision",
    name: "finalTaxType",
    label: "สุดท้ายแล้ว\nคุณคิดว่าจะเสียภาษีแบบไหน?",
    options: [
      {
        value: "personal",
        image: IMG.FINAL_DECISION_PERSONAL,
        label: "บุคคลธรรมดา",
        nextPath: "/summaries/personal_decision",
      },
      {
        value: "corp",
        image: IMG.FINAL_DECISION_CORP,
        label: "นิติบุคคล",
        nextPath: "/summaries/corp_decision",
      },
    ],
  },
];

export const getAnswerImage = (name, value) => {
  try {
    const state = QUESTION_INFO.find((state) => state.name === name);
    const option = state.options.find((option) => option.value === value);
    return option.image;
  } catch {
    return undefined;
  }
};

export default {
  name: "StateAnswer",
  props: {},
  data() {
    return {};
  },
  computed: {
    items() {
      const answers = this.$store.state.questions.answers;
      const questionPaths = this.$store.state.questions.questionPaths;
      const currentPath = this.$route.path;

      let items = questionPaths.map((path) => {
        const state = QUESTION_INFO.find((state) => state.path === path);
        const option =
          state.options.find((opt) => opt.value === answers[state.name]) || {};

        if (state) {
          return {
            image: option.image,
            path: state.path,
            active: state.path === currentPath,
          };
        }
      });

      items = items.filter((item) => item);
      const hasActive = !!items.find((item) => item.active);

      if (!hasActive && items.length > 0) {
        const lastItem = items[items.length - 1];
        lastItem.active = true;
      }

      return items;
    },
    isShow() {
      return this.items.filter((item) => item.image).length > 0;
    },
  },
  mounted() {
    const currentQuestionPath = QUESTION_INFO.map((state) => state.path).find(
      (path) => path === this.$route.path
    );
    if (currentQuestionPath) {
      const oldQuestionPaths = Vue.lodash.uniq([
        ...this.$store.state.questions.questionPaths,
        currentQuestionPath,
      ]);

      const newQuestionPaths = QUESTION_INFO.map(
        (state) => state.path
      ).filter((path) => oldQuestionPaths.includes(path));

      this.$store.dispatch("questions/setQuestionPaths", {
        questionPaths: newQuestionPaths,
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.state-answer {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: auto;
  position: relative;

  padding: 0px 30px;
  box-sizing: border-box;
}
.dash {
  border-top: 1px solid #e6e8ec;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  top: 0;
}
.label-state {
  position: absolute;
  top: 4px;
  font-size: 12px;
  color: #000000;
  width: 100%;
  padding: 0px 10px;
  max-width: 1120px;
  box-sizing: border-box;
}
.body {
  display: flex;
  position: relative;
  align-items: center;
}
.line {
  z-index: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: calc(50% - 1px);
  width: 100%;
  height: 2px;
  background: #e6e8ec;
}
.answer {
  z-index: 1;
  border-radius: 50%;
  background: #e6e8ec;
  margin-left: 17px;
  width: 24px;
  height: 24px;
  overflow: hidden;
}
.answer:nth-child(2) {
  margin-left: 0px;
}
.answer:hover {
  cursor: pointer;
}
.answer.active {
  width: 64px;
  height: 64px;
}
.answer img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .label-state {
    top: 40%;
  }
}
</style>
